// Components==============
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button/Button';
import RichText from 'components/UI/RichText/RichText';
import Search from 'components/UI/Search/Search';
import SparkGroup from 'components/UI/SparkGroup/SparkGroup';
import { AnimatePresence } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useSparkGroups } from 'hooks/useSparkGroups';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useState } from 'react';
import { SkillModalContext } from '../SkillModal';
import './SparkView.module.scss';
// =========================

export default function SparkView() {
  const translate = useTranslate();

  const { selected, setSelected, setShowOverview } = useContext(
    SkillModalContext
  );

  const [value, setValue] = useState('');

  const sparks = useRedux((state) =>
    state.spark?.entities.allIds.map((id) => state.spark?.entities.byId[id])
  )
    ?.filter((spark) => spark?.skill_id === selected?.id)
    .filter((spark) => spark?.name.toLowerCase().includes(value.toLowerCase()));

  const sparkGroups = useSparkGroups(sparks);

  return (
    <div styleName="wrapper">
      <div styleName="top">
        <Button color="grey-black" onClick={() => setSelected(undefined)}>
          <FontAwesomeIcon icon={faChevronLeft} />
          {translate('reflection.terms.all-skills')}
        </Button>
        <Button color="grey-black" onClick={() => setShowOverview(true)}>
          {translate('general.terms.know-more')}
        </Button>
        <div styleName="search">
          <Search value={value} setValue={setValue} fluid />
        </div>
      </div>
      <div styleName="content">
        <div styleName="description">
          <RichText content={selected?.description} />{' '}
        </div>
        {!!sparks?.length && (
          <div>
            <div styleName="groups">
              <AnimatePresence>
                {sparkGroups?.map((group, index) => (
                  <SparkGroup key={index} group={group} value={value} />
                ))}
              </AnimatePresence>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
